import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { RESOLUTION_SELECTION } from '../../containers/OrderHelpTemplateContainer/templateTypes';

import ModalFooter from '../ModalFooter';
import OrderHelpResolutionList from '../OrderHelpResolutions';

/**
 * A generic dynamic actions template to render a list of resolutions to select.
 */
class OrderHelpTemplateResolutionSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedResolution: props.data.resolutions[0],
    };

    this.onPickResolution = this.onPickResolution.bind(this);
  }

  onPickResolution(resolutionId) {
    this.setState({
      selectedResolution: resolutionId,
    });
  }

  render() {
    const {
      iframe,
      data: { resolutions },
      actionId,
      hideFooterPrevious,
      requestInteraction,
    } = this.props;

    const { selectedResolution } = this.state;

    return (
      <Fragment>
        <OrderHelpResolutionList
          onPickResolution={this.onPickResolution}
          resolutions={resolutions}
          selectedResolutionId={selectedResolution.id}
          modal={iframe}
        />

        <ModalFooter
          onSubmit={() => {
            requestInteraction({
              parentActionId: actionId,
              parentActionTemplate: RESOLUTION_SELECTION,
              templateData: {
                resolution_id: selectedResolution.id,
              },
            });
          }}
          cta={selectedResolution.cta}
          modal={iframe}
          hidePrevious={hideFooterPrevious}
        />
      </Fragment>
    );
  }
}

OrderHelpTemplateResolutionSelection.propTypes = {
  /**
   * Whether to style the template appropriately for a modal.
   */
  iframe: PropTypes.bool.isRequired,
  /**
   * Which help screen the template is currently on.
   */
  actionId: PropTypes.string.isRequired,
  /**
   * Template data to fill out the generic template.
   */
  data: PropTypes.shape({
    resolutions: PropTypes.arrayOf(PropTypes.object),
  }),
  /**
   * Whether to hide the previous button for the footer
   */
  hideFooterPrevious: PropTypes.bool,
  /**
   * The dispatch action that will be triggered onClick for each OrderHelpActionRows.
   * This will be used to update the dynamic action and grab the next self help page
   */
  requestInteraction: PropTypes.func.isRequired,
};

OrderHelpTemplateResolutionSelection.defaultProps = {
  data: {},
  hideFooterPrevious: true,
};

export default OrderHelpTemplateResolutionSelection;
